import React, {Component} from 'react';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import firebase from 'firebase';
import secondaryApp from '../BD/secondaryApp';
const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'	
  }
};


class ModalUsuarios extends Component{
	
		constructor(props){
			
			super(props);
			this.state={
				isActive:false,
				perfiles:[]				
			}
			//Referencia al nodo de usuarios de firebase
			this.UsuarioAcacyaRef=database.ref().child('Usuarios_Acacya');
			
			//Referncia al nodo de perfiles de firebase
			this.PerfilesRef=database.ref().child('Perfiles');
			
			//Funcion para crear items para los select  de tipos de perfil
			this.MakeItems=this.MakeItems.bind(this);
			
			//Función para el envio del formulario
			this.handleSubmit=this.handleSubmit.bind(this);
			
			this.toggleModal=this.toggleModal.bind(this);
		}
	
		
		componentDidMount(){
			
			this.PerfilesRef.on('value',this.gotData,this.errData);
		}
	
		componentWillMount(){
			
			Modal.setAppElement('body');
			
		}
	
		gotData=(data)=>{
			
			let newPerfil=[];
			
			const perfilesdata=data.val();
			
			//Si el nodo de perfiles no esta vacio
			if(perfilesdata!=null){
				
				const keys = Object.keys(perfilesdata);
				
				for (let i = 0; i < keys.length; i++) {
					const k = keys[i];
					
					newPerfil.push({
						key:k,
						nombre:perfilesdata[k].nombre				  
					});				
				}
				 this.setState({perfiles: newPerfil});			
			}		
		}
		errData=(err)=>{		
			console.log(err)
		}
	
	
	
		toggleModal(){			
			this.setState({				
				isActive:!this.state.isActive
			});		
		}
	
		//Retorna las opciones para llenar el select de los perfiles
		MakeItems(x){
			return <option>{x.nombre}</option>;		
		}
		
		//Función para el envio del formulario
		handleSubmit(event){

			let nombre=this.nombreUsuario.value;
			let correo=this.correoUsuario.value;
			let password=this.passwordUsuario.value;
			let confpassword=this.confpasswordUsuario.value;
			let perfil=this.perfilUsuario.value;
			let estado=this.estadoUsuario.value;
			
			if(password===confpassword){
				
					
					secondaryApp.auth().createUserWithEmailAndPassword(correo,password)
					.then(user => {
						
							
							this.UsuarioAcacyaRef.child(user.uid).update({
								
									nombre:nombre,
									correo:correo,
									password:password,
									perfil:perfil,
									estado:estado						
							})	
								
							Alert.success('Datos ingresados con exito', {
									effect: 'genie',
									position: 'bottom-right',
									timeout:2000
									
							});
								
							secondaryApp.auth().signOut();	
							
							this.toggleModal();
					})
					.catch(error =>{
				
							let msj='Error al ingresar usuario';
						
							if(error.code==='auth/email-already-in-use'){	
								msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
							}
							else if(error.code==='auth/invalid-email'){					
								msj='Dirección de correo electronico no valida.';					
							}
							
							else if(error.code==='auth/weak-password'){
								
								msj='La contraseña ingresada no es demasiado fuerte.';
									
							}

							Alert.error(msj, {
									effect: 'genie',
									position: 'bottom-right',
									timeout:2000			
							});
				
					
					});				
			}
			else{
				
					Alert.error('Las contraseñas ingresadas no coinciden', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000
						
					});
			}
			
			event.preventDefault();
			
		}
		
	
	
		render(){
			
			
			return(
					
				<div className="modal_usuarios">
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
					
					<Alert stack={{limit: 3}} html={true} />
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
						
					
						<form method="POST" action="" onSubmit={this.handleSubmit}>
						
						
							<h4>Editar Usuario</h4>							
							<hr/>
							<div className="form-group">
								<label htmlFor="">Nombre del empleado</label>
								<input type="text" name="" placeholder="Nombre del empleado" className="form-control" required autoComplete="off"								
								ref={input => {this.nombreUsuario=input;}}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Correo</label>
								<input type="text" name="" placeholder="Correo" className="form-control" required autoComplete="off"
								ref={input => {this.correoUsuario=input;}}								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Contraseña</label>
								<input type="password" name="" placeholder="Contraseña" className="form-control" required autoComplete="off"
								ref={input => {this.passwordUsuario=input;}}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Confirmar Contraseña</label>
								<input type="password" name="" placeholder="Confirmar Contraseña" className="form-control" required autoComplete="off"
								ref={input => {this.confpasswordUsuario=input;}}								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Perfil</label>
								<select className="form-control"  
								ref={input => {this.perfilUsuario=input;}}
								>
									{this.state.perfiles.map(this.MakeItems)}
									
								</select>
							</div>
							<div className="form-group">
								<label htmlFor="">Estado</label>
								<select className="form-control"
								ref={input => {this.estadoUsuario=input;}}
								>
									<option value="Activo">Activo</option>
									<option value="Inactivo">Inactivo</option>
								</select>
							</div>							
							
						<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
					</Modal> 
					
					
				</div>
			
			);
			
			
			
		}
	
	
}


export default ModalUsuarios;




// WEBPACK FOOTER //
// ./src/Components/Usuarios/ModalUsuarios.js